import isEqual from 'lodash/isEqual';
import { useCallback, useEffect, useState } from 'react';
// @mui
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import { alpha } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Tabs from '@mui/material/Tabs';
import Tooltip from '@mui/material/Tooltip';
// routes
import { useRouter } from 'src/routes/hooks';
import { paths } from 'src/routes/paths';
// _mock
import { _roles, _userList, USER_STATUS_OPTIONS, USER_STATUS_OPTIONS_ROLE } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { ConfirmDialog } from 'src/components/custom-dialog';
import Iconify from 'src/components/iconify';
import Label from 'src/components/label';
import Scrollbar from 'src/components/scrollbar';
import { useSettingsContext } from 'src/components/settings';
import {
    emptyRows, getComparator, TableEmptyRows,
    TableHeadCustom,
    TableNoData,
    TableSelectedAction,
    useTable
} from 'src/components/table';

import { deleteRequest, getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

import TablePaginationApiBased from 'src/components/table/table-pagination-api-based-urls';
import { RouterLink } from 'src/routes/components';
import UserTableToolbar from './general-table-toolebar';
import UserTableFiltersResult from './general-table-filter';
import UserTableRow from './general-table-row';
import { Box } from '@mui/material';
import { LoadingScreen } from 'src/components/loading-screen';
import { applyFilter } from 'src/services/fetching';


//

// ----------------------------------------------------------------------

const STATUS_OPTIONS = [ { value: 'all', label: 'All' }, ...USER_STATUS_OPTIONS ];


const TABLE_HEAD = [
    { id: 'name', label: 'Subject' },
    { id: 'phoneNumber', label: 'Created Date' },
    { id: 'company', label: 'Sedhuled Date' },
    { id: 'company', label: 'Sedhuled Time' },
    { id: 'status', label: 'Status' },
    { id: 'actions', label: 'Actions' },
];


const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
    active: 'all',
};

// ----------------------------------------------------------------------

export default function GeneralTable() {

    const [ tableData, setTableData ] = useState({ data: [], pagination: {} });
    console.log(tableData, 'tableData')
    const [ loading, setLoading ] = useState(false);

    const table = useTable();
    const settings = useSettingsContext();
    const router = useRouter();
    const confirm = useBoolean();


    useEffect(() => {
        getProductUpdates();
    }, [ table.page, table.rowsPerPage ]);

    const getProductUpdates = async (page = 1) => {
        const url = `${endpoints.admin_dashboard.product_updates.newsletter.get_list}`;
        const queryParams = new URLSearchParams({ type: "general", page, is_paginate: true }).toString();
        setLoading(true)

        const data = await getRequest(`${url}?${queryParams}`);
        if (data) {
            console.log("🚀 ~ getProductUpdates ~ data:", data);
            setTableData(data || []);
        }
        setLoading(false)

    };

    const [ filters, setFilters ] = useState(defaultFilters);

    const dataFiltered = applyFilter({
        inputData: tableData.data,
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });
    const denseHeight = table.dense ? 52 : 72;
    const canReset = !isEqual(defaultFilters, filters);
    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

    const handleFilters = useCallback(
        (name, value) => {
            table.onResetPage();
            setFilters((prevState) => ({
                ...prevState,
                [ name ]: value,
            }));
        },
        [ table ]
    );

    const handleEditRow = useCallback(
        (id) => {
            router.push(paths.dashboard.user.edit(id));
        },
        [ router ]
    );

    const handleFilterStatus = useCallback(
        (event, newValue) => {
            handleFilters('status', newValue);
        },
        [ handleFilters ]
    );

    const handleResetFilters = useCallback(() => {
        setFilters(defaultFilters);
    }, []);
    const deleteCallBack = () => {
        confirm.onFalse();
        getProductUpdates()
    }
    const handleDeleteRows = async (id) => {
        await deleteRequest(`${endpoints.admin_dashboard.product_updates.newsletter.delete}/${id}`, deleteCallBack);
    }


    return (
        <>
            { loading ? (
                <Box height={ 700 }>
                    <LoadingScreen />
                </Box>
            ) : (
                <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
                    <CustomBreadcrumbs
                        heading="General"
                        links={ [
                            { name: '', href: paths.dashboard.root },

                        ] }
                        action={
                            <Button
                                component={ RouterLink }
                                href={ paths.dashboard.product_user_general_create }
                                variant="contained"
                                startIcon={ <Iconify icon="mingcute:add-line" /> }
                            >
                                Create
                            </Button>
                        }
                        sx={ {
                            mb: { xs: 3, md: 5 },
                        } }
                    />


                    <Card>
                        <Tabs
                            value={ filters.status }
                            onChange={ handleFilterStatus }
                            sx={ {
                                px: 2.5,
                                boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[ 500 ], 0.08)}`,
                            } }
                        >
                            { USER_STATUS_OPTIONS_ROLE.map((tab) => (
                                <Tab
                                    key={ tab.value }
                                    iconPosition="end"
                                    value={ tab.value }
                                    label={ tab.label }
                                    icon={
                                        <Label
                                            variant={
                                                ((tab.value === 'all' || tab.value === filters.status) && 'filled') || 'soft'
                                            }
                                            color={
                                                (tab.value === 'active' && 'success') ||
                                                'default'
                                            }
                                        >
                                            { tab.value === 'all' && _userList.length }
                                            { tab.value === 'active' &&
                                                _userList.filter((user) => user.status === 'active').length }

                                            { tab.value === 'inactive' &&
                                                _userList.filter((user) => user.status === 'inactive').length }

                                        </Label>
                                    }
                                />
                            )) }
                        </Tabs>
                        <UserTableToolbar
                            filters={ filters }
                            onFilters={ handleFilters }
                            //
                            roleOptions={ _roles }
                        />
                        { canReset && (
                            <UserTableFiltersResult
                                filters={ filters }
                                onFilters={ handleFilters }
                                //
                                onResetFilters={ handleResetFilters }
                                //
                                results={ dataFiltered?.length }
                                sx={ { p: 2.5, pt: 0 } }
                            />
                        ) }
                        <TableContainer sx={ { position: 'relative', overflow: 'unset' } }>
                            <TableSelectedAction
                                dense={ table.dense }
                                numSelected={ table?.selected.length }
                                rowCount={ dataFiltered?.length }
                                onSelectAllRows={ (checked) =>
                                    table.onSelectAllRows(
                                        checked,
                                        dataFiltered?.map((row) => row.id)
                                    )
                                }
                                action={
                                    <Tooltip title="Delete">
                                        <IconButton color="primary" onClick={ confirm.onTrue }>
                                            <Iconify icon="solar:trash-bin-trash-bold" />
                                        </IconButton>
                                    </Tooltip>
                                }
                            />
                            <Scrollbar>
                                <Table size={ table.dense ? 'small' : 'medium' } sx={ { minWidth: 960 } }>
                                    <TableHeadCustom
                                        order={ table?.order }
                                        orderBy={ table?.orderBy }
                                        headLabel={ TABLE_HEAD }
                                        rowCount={ dataFiltered?.length }
                                        numSelected={ table?.selected.length }
                                        onSort={ table?.onSort }
                                        onSelectAllRows={ (checked) =>
                                            table?.onSelectAllRows(
                                                checked,
                                                dataFiltered?.map((row) => row.id)
                                            )
                                        }
                                    />
                                    <TableBody>
                                        { dataFiltered?.map((row) => (
                                            <UserTableRow
                                                key={ row.id }
                                                row={ row }
                                                selected={ table.selected.includes(row.id) }
                                                onSelectRow={ () => table.onSelectRow(row.id) }
                                                onDeleteRow={ () => handleDeleteRows(row.id) }
                                                onEditRow={ () => handleEditRow(row.id) }
                                            />
                                        )) }
                                        <TableEmptyRows
                                            height={ denseHeight }
                                            emptyRows={ emptyRows(table?.page, table?.rowsPerPage, tableData?.length) }
                                        />

                                        {/* <TableNoData notFound={ notFound } /> */ }
                                    </TableBody>
                                </Table>
                            </Scrollbar>
                        </TableContainer>

                        <TablePaginationApiBased
                            paginationLinks={ tableData }
                            onPageChange={ (page) => getProductUpdates(page) }
                        />

                    </Card>
                </Container>
            ) }
            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content={
                    <>
                        Are you sure want to delete <strong> { table.selected.length } </strong> items?
                    </>
                }
                action={
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ () => {
                            handleDeleteRows();
                            confirm.onFalse();
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}

// ----------------------------------------------------------------------

